import { useContext, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import getMembershipPlanName from "../../../controllers/getMembershipPlanName";
import Context from "../../../Context";
import parseExpiresAt from "../../../controllers/parseExpiresAt";
import CustomButton from "../../helperComponents/CustomButton";

const MembershipMiniInfo = ({}) => {
  const { loggedInUser, isMobile, membershipPlans, updateMembershipPlans } =
    useContext(Context);

  const { t } = useTranslation();

  useEffect(() => {
    updateMembershipPlans();
  }, []);

  if (!membershipPlans) return null;

  let membershipIdVsPlan = {};

  for (let item of membershipPlans) {
    membershipIdVsPlan[item._id] = item;
  }

  let planName = getMembershipPlanName({
    membershipIdVsPlan,
    membershipPlanID: loggedInUser.membershipPlanID,
  });

  return (
    <CustomButton
      href={"/membership"}
      style={{ borderRadius: "10px", height: isMobile ? "40px" : "65px" }}
      textStyle={{ fontSize: "9px" }}
    >
      {getContent()}
    </CustomButton>
  );

  function getContent() {
    let expiry = parseExpiresAt(loggedInUser.membershipPlanValidity);

    if (!planName || !expiry || planName == "NA") return t("noMembershipPlan");

    return planName;
    // return `${planName}: ${parseExpiresAt(loggedInUser.membershipPlanValidity)} Days`;
  }
};

/*

Old content
*/

export default MembershipMiniInfo;
